const Reflux = require('@muzzylane/reflux');
const get = require('lodash/get');
const uuid = require('uuid');
const _ = {
    find: require('lodash/find'),
    findIndex: require('lodash/findIndex'),
    reject: require('lodash/reject'),
};


const ForgeError = require('../util/error');
const BadgeActions = require('../actions/BadgeActions');

let initializedChannels = {};
let channelBadgeTemplates = {}; // channelBadgeTemplates[channelId] = array of badge templates available to the channel user

let initializedOrgServices = {};
let initializedOrgTemplates = {};
let orgBadgeServices = {}; // orgBadgeServices[orgId] = array of badge templates for the org 
let orgBadgeTemplates = {}; // orgBadgeTemplates[orgId] = array of badge templates for the org 

let action = {};


const BadgeStore = Reflux.createStore({
    listenables: [BadgeActions],
    init: function() {},

    resetState: function() {
        initializedOrgServices = {};
        initializedOrgTemplates = {};
        orgBadgeServices = {};
        orgBadgeTemplates = {};

        initializedChannels = {};
        channelBadgeTemplates = {};
        
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            orgBadgeServices, initializedOrgServices,
            orgBadgeTemplates, initializedOrgTemplates,
            channelBadgeTemplates, initializedChannels,
            action,
        };
    },

    getStateChannel: function(channelId) {
        return {
            badgeTemplatesInitialized: this.getChannelInitialized(channelId),
            badgeTemplates: get(channelBadgeTemplates, `${channelId}`, []),
            action: action,
        }
    },

    getStateOrg: function(orgId) {
        return {
            badgeServicesInitialized: this.getOrgServicesInitialized(orgId),
            badgeTemplatesInitialized: this.getOrgTemplatesInitialized(orgId),
            badgeServices: get(orgBadgeServices, `${orgId}`, []),
            badgeTemplates: get(orgBadgeTemplates, `${orgId}`, []),
            action: action,
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    setChannelInitialized(channelId, badgeTemplatesInitialized=true) {
        const pChannelId = parseInt(channelId, 10);
        initializedChannels[pChannelId] = badgeTemplatesInitialized;
    },

    getChannelInitialized(channelId) {
        const pChannelId = parseInt(channelId, 10);
        return initializedChannels[channelId];
    },

    getOrgServicesInitialized(orgId) {
        const pOrgId = parseInt(orgId, 10);
        return initializedOrgServices[orgId];
    },

    getOrgTemplatesInitialized(orgId) {
        const pOrgId = parseInt(orgId, 10);
        return initializedOrgTemplates[orgId];
    },

    onError: function(actionId, err) {
        action.id = actionId;
        if (err.status) {
            switch (err.status) {
                default:
                    action.error = new ForgeError({ message: err.responseText, stack: null }); // assume short course related requests provide user-facing error text
                    break;
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },
    

    onGetBadgeServicesCompleted: function(actionId, orgId, badgeServiceArr) {
        action = { id: actionId };
        const pOrgId = parseInt(orgId, 10);
        orgBadgeServices[pOrgId] = badgeServiceArr;
        initializedOrgServices[pOrgId] = true;
        this.emitStatus();
    },

    onGetBadgeServicesFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddBadgeServiceCompleted: function(actionId, orgId, badgeServiceData) {
        action = { id: actionId };
        const pOrgId = parseInt(orgId, 10);
        let badgeServices = orgBadgeServices[pOrgId];
        let index = _.findIndex(badgeServices,{id: badgeServiceData.id});
        if (index >= 0) {
            console.log(`onAddBadgeServiceCompleted already had id ${badgeServiceData.id}`);
        }
        else {
            badgeServices.push(badgeServiceData);
        }
        this.emitStatus();
    },

    onAddBadgeServiceFailed: function(actionId, orgId, err) {
        console.log("onAddBadgeServiceFailed:",err); // FIXME: remove debug spam
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    
    onUpdateBadgeServiceCompleted: function(actionId, orgId, badgeServiceData) {
        action = { id: actionId };
        const pOrgId = parseInt(orgId, 10);
        let badgeServices = orgBadgeServices[pOrgId];
        let index = _.findIndex(badgeServices,{id: badgeServiceData.id});
        if (index >= 0) {
            badgeServices[index] = badgeServiceData;
        }
        else {
            console.log(`onUpdateBadgeServiceCompleted failed to find id ${badgeServiceData.id}`);
        }
        this.emitStatus();
    },

    onUpdateBadgeServiceFailed: function(actionId, orgId, err) {
        console.log("onUpdateBadgeServiceFailed:",err); // FIXME: remove debug spam
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetBadgeTemplatesCompleted: function(actionId, orgId, badgeTemplateArr) {
        action = { id: actionId };
        const pOrgId = parseInt(orgId, 10);
        orgBadgeTemplates[pOrgId] = badgeTemplateArr;
        initializedOrgTemplates[pOrgId] = true;
        this.emitStatus();
    },

    onGetBadgeTemplatesFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddBadgeTemplateCompleted: function(actionId, orgId, newBadgeTemplate) {
        action = { id: actionId };
        const pOrgId = parseInt(orgId, 10);
        let badgeServices = orgBadgeServices[pOrgId]
        const bs = _.find(badgeServices,{id: newBadgeTemplate.badge_service_id});
        let bt = {
            badge_template_hash: newBadgeTemplate.badge_template_hash,
            badge_service_id: bs.id,
            badge_service_name: bs.name,
            display_name: newBadgeTemplate.display_name
        };
        let badgeTemplates = orgBadgeTemplates[pOrgId];
        let index = _.findIndex(badgeTemplates,{badge_template_hash: bt.badge_template_hash});
        if (index < 0) {
            badgeTemplates.push(bt);
        }
        else {
            console.log(`onAddBadgeTemplateCompleted already had ${newBadgeTemplate.badge_template_hash}`);
        }
        this.emitStatus();
    },

    onAddBadgeTemplateFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onUpdateBadgeTemplateCompleted: function(actionId, orgId, updatedBadgeTemplate) {
        action = { id: actionId };
        const pOrgId = parseInt(orgId, 10);
        let badgeTemplates = orgBadgeTemplates[pOrgId];
        let bt = _.find(badgeTemplates,{badge_template_hash: updatedBadgeTemplate.badge_template_hash});
        if (bt) {
            bt.img_src = updatedBadgeTemplate.img_src;
        }
        this.emitStatus();
    },

    onUpdateBadgeTemplateFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onRemoveBadgeTemplateCompleted: function(actionId, orgId, result) {
        action = { id: actionId };
        const pOrgId = parseInt(orgId, 10);
        if (orgBadgeTemplates[pOrgId]) {
            let after = _.reject(orgBadgeTemplates[pOrgId],{ badge_template_hash: result.badge_template_hash });
            orgBadgeTemplates[pOrgId] = after;
            // TODO: update channel(s)?
            this.emitStatus();
        }
        else {
            console.log(`no templates for org ${orgId}`); // FIXME: remove debug spam
        }
    },

    onRemoveBadgeTemplateFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        console.log("onRemoveOrgBadgeTemplateFailed",orgId, err);
        this.emitStatus();
    },


    onGetBadgeTemplateDetailsCompleted: function(actionId, orgId, result) {
        action = { id: actionId };
        const pOrgId = parseInt(orgId, 10);
        if (orgBadgeTemplates[pOrgId]) {
            let i = _.findIndex(orgBadgeTemplates[pOrgId],{badge_template_hash: result.badgeTemplateHash});
            if (i>=0) {
                orgBadgeTemplates[pOrgId][i].url = result.url;
                orgBadgeTemplates[pOrgId][i].img_src = result.img_src;
                console.log("other badge details:",result.details); // FIXME: remove debug spam
            }
        }
        this.emitStatus();
    },

    onGetBadgeTemplateDetailsFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        console.log("onGetBadgeTemplateDetailsFailed",orgId, err);
        this.emitStatus();
    },


    onGetChannelBadgeTemplatesCompleted: function(actionId, channelId, badgeTemplateArr) {
        action = { id: actionId };
        channelBadgeTemplates[channelId] = badgeTemplateArr;
        this.setChannelInitialized(channelId);
        this.emitStatus();
    },

    onGetChannelBadgeTemplatesFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },


});

module.exports = BadgeStore;